export const lensDisplayInfoOrDefault = (lensDisplayInfo) => lensDisplayInfo ||
    {
        scannableUuid: "",
        lensName: "",
        lensCreatorDisplayName: "",
        lensPreviewImageUrl: "",
        lensPreviewVideoUrl: "",
        iconUrl: "",
        unlockUrl: "",
        lensResource: undefined,
        userProfileUrl: "",
        lensCreatorUsername: "",
        lensId: "",
        lensCreatorSearchTags: [],
        isOfficialSnapLens: false,
    };
